import vars from '../helpers';

const checker = () => {
	const $aos = $('[data-aos]');

	$aos.each((i, e) => {
		if (!$(e).data('aos-delay')) {
			return;
		}

		if ($(e).offset().top > window.innerHeight) {
			$(e).attr('data-aos-delay', '0');
		}
	});
};

const init = () => {
	AOS.init({
		disable: innerWidth <= 1024,
		duration: 750,
		// easing: 'ease-out-quart',
		once: true,
	});

	vars.$document.on('aos:in:title.lines', ({detail}) => {
		const $title = $(detail);

		if (+$title.data('view') > 0) {
			return;
		}

		$title.data('view', '1');
		// const $line = $title.closest('.js-title').find('.js-line');

		// const tl = gsap.timeline();

		// const n = $line.data('delay');
		// const direction = $line.data('direction') ? $line.data('direction') : 'right';
		// let dx = '-100%';
		// let dy = 0;
		// let duration = 2;
		// let delay = 0;

		// if (direction === 'left') {
		// 	dx = '100%';
		// }

		// if (direction === 'bottom') {
		// 	dx = 0;
		// 	dy = '-100%';
		// 	duration = 12;
		// }

		// tl.from($line, {
		// 	onStart() {
		// 		$line.removeClass('is-hidden');
		// 	},
		// 	x: '-100%',
		// 	duration: 1,
		// 	clearProps: 'all',
		// }, 0.5);
	});
};

const refresh = () => {
	$('.aos-animate').removeClass('aos-animate');

	setTimeout(() => {
		AOS.refreshHard();
	}, 50);

	setTimeout(() => {
		checker();
	}, 75);

	vars.$window.on('load.aos', AOS.refreshHard);

	vars.$html.on('aos-refresh.aos', () => {
		AOS.refresh();
	});
};

const destroy = () => {
	vars.$window.off('.aos');
};

const resize = () => {
	destroy();
	init();
};

export default {
	init,
	destroy,
	resize,
	refresh,
};
